import {
	Injectable
} from '@angular/core';

import {
	RuntimeConfigLoaderService
} from 'runtime-config-loader';

@Injectable({
	providedIn: 'root',
})
export class AvvcAccessGuardService {
	constructor(
		private runtimeConfigService: RuntimeConfigLoaderService
	) {}

	canActivate(): Promise<boolean> {
		return new Promise(resolve => {
			this.runtimeConfigService.configSubject.subscribe(config => {
				if (!config.isAVVCActivated) {
					window.location.href = '/accueil/';
					resolve(false);
				} else {
					resolve(true);
				}
			});
		});
	}
}
